<template>
    <div>
        <div style="margin-bottom: 5px">
            <el-input
                v-model="name"
                placeholder="请输入进货单号"
                suffix-icon="el-icon-a-042"
                style="width: 200px"
                @keyup.enter.native="loadPost"
            ></el-input>
			<el-date-picker
			style="margin-left: 5px; font-size: 18px"
			  v-model="daterange"
			  type="daterange"
			  align="right"
			  unlink-panels
			  range-separator="至"
			  start-placeholder="开始日期"
			  end-placeholder="结束日期"
			  :picker-options="pickerOptions">
			</el-date-picker>
            <el-button
                type="primary"
                style="margin-left: 5px; font-size: 18px"
                @click="loadPost"
            >
                查询</el-button
            >
            <el-button
                type="warning"
                @click="resetParam"
                style="font-size: 18px"
            >
                重置</el-button
            >

            <el-button
                type="primary"
                style="margin-left: 5px; font-size: 18px"
                @click="add"
            >
                生成进货单</el-button
            >
        </div>
        <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
            border
        >
            <!-- <el-table-column prop="id" label="ID" width="60"> </el-table-column> -->
            <el-table-column prop="buyOrderNo" label="进货单号" width="150"></el-table-column>
			<el-table-column prop="buyOrderTime" :formatter="formatDateTime" label="进货单时间" width="150"></el-table-column>
			<el-table-column prop="buyTime" :formatter="formatDateTime" label="进货时间" width="180"></el-table-column>
			<el-table-column prop="buyStatus" label="订货状态" :formatter="orderInfoState" width="100"></el-table-column>
			<el-table-column prop="totalMoney" label="进货总金额" width="150"></el-table-column>
            <el-table-column prop="remarks" label="备注" width="250"> </el-table-column>
            <el-table-column
                prop="operate"
                label="操作"
                width="400"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        slot="reference"
                        style="font-size: 18px"
                        type="danger"
						@click="showUserOrderList(scope.row)"
                    >
                        订货单</el-button
                    >
					<el-button
					    slot="reference"
					    style="font-size: 18px"
					    type="success"
						@click="showDetails(scope.row)"
					>
					    进货商品</el-button
					>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>

		
		<el-dialog
		    title="订货单列表"
		    :visible.sync="userOrderListVisible"
		    width="75%"
		    center
		>
			<UserOrderList :buyOrderId="buyOrderId"></UserOrderList>
			<span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="userOrderListVisible = false" style="font-size: 18px"
			        >
			        确 定</el-button
			    >
			</span>
		</el-dialog>
		
		<el-dialog
		    title="选择订货单"
		    :visible.sync="userOrderSelectVisible"
		    width="75%"
		    center
		>
			<UserOrderSelect @doSelectUserOrder="doSelectUserOrder" :userOrderSelectVisible="userOrderSelectVisible"></UserOrderSelect>
			<span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="doSaveBuyOrder" style="font-size: 18px"
			        >
			        确 定</el-button
			    >
			</span>
		</el-dialog>
		
		<el-dialog
		    title="进货单详情"
		    :visible.sync="orderInfoVisible"
		    width="75%"
		    center
		>
			<BuyOrderInfo :userOrderId="userOrderId" :userOrderNo="userOrderNo"></BuyOrderInfo>
			<span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="orderInfoVisible = false" style="font-size: 18px"
			        >
			        确 定</el-button
			    >
			</span>
		</el-dialog>
    </div>
</template>

<script>
	import BuyOrderInfo from "./BuyOrderInfo";
	import UserOrderList from "./UserOrderList";
	import UserOrderSelect from "./UserOrderSelect";
export default {
    name: "UserOrderManage",
	components: { BuyOrderInfo,UserOrderList,UserOrderSelect },
    data() {
        return {
			userOrderId:"",
			userOrderNo:"",
			buyOrderId:"",
			tempGoods:{},
            tableData: [],
            pageSize: 10,
            pageNum: 1,
            total: 0,
            name: "",
			daterange:"",
			pickerOptions: {
			          shortcuts: [{
			            text: '最近一周',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			              picker.$emit('pick', [start, end]);
			            }
			          }, {
			            text: '最近一个月',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			              picker.$emit('pick', [start, end]);
			            }
			          }, {
			            text: '最近三个月',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			              picker.$emit('pick', [start, end]);
			            }
			          }]
			        },
			userOrderListVisible: false,
            centerDialogVisible: false,
			orderInfoVisible:false,
			userOrderSelectVisible:false,
            form: {
                userOrderIds: [],
				remarks:""
            },
			orderInfo:{
				userOrderId:"",
				userOrderNo:"",
				goodsId:"",
				goodsName:"",
				goodsNum:"",
				remarks:"",
				fee:"",
				unit:""
			},
            rules: {
                userName: [
                    {
                        required: true,
                        message: "请选择下单人",
                        trigger: "blur",
                    },
                ],
            },
			orderInfoRules: {
			    goodsName: [
			        {
			            required: true,
			            message: "请选择商品",
			            trigger: "blur",
			        },
			    ],
				goodsNum: [
				    {
				        required: true,
				        message: "请输入商品数量",
				        trigger: "blur",
				    },
				],
			},
			// 1待进货，2进货中，3已完成
			orderInfoStatus:[
				{
					id:1,
					name:"待进货"
				},
				{
					id:2,
					name:"进货中"
				},
				{
					id:3,
					name:"已完成"
				}
			]
        };
    },
	watch:{
		orderInfoVisible:{
			handler(newVal,oldVal){
				if(!newVal){
					this.userOrderId=null
				}
			},
			deep:true,
			immediate:true
		},
		userOrderListVisible:{
			handler(newVal,oldVal){
				if(!newVal){
					this.buyOrderId=null
				}
			},
			deep:true,
			immediate:true
		},
		userOrderSelectVisible:{
			handler(newVal,oldVal){
				if(!newVal){
					this.buyOrderId=null
				}
			},
			deep:true,
			immediate:true
		}
	},
    methods: {
		
		formatDateTime(row, column, cellValue, index) {
			console.log(cellValue)
			if(!cellValue){
				return "-"
			}
		  function padZero(num) {
		    return num < 10 ? '0' + num : num;
		  }
		 var date=new Date(cellValue)
		  var year = date.getFullYear();
		  var month = padZero(date.getMonth() + 1);
		  var day = padZero(date.getDate());
		  var hours = padZero(date.getHours());
		  var minutes = padZero(date.getMinutes());
		  var seconds = padZero(date.getSeconds());
		 
		  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
		},
		orderInfoState(row){
			let temp = this.orderInfoStatus.find((item) => {
			    return item.id == row.buyStatus;
			});
			
			return temp && temp.name;
		},
		showDetails(val){
			console.log(val)
			this.userOrderId=val.id;
			this.userOrderNo=val.buyOrderNo;
			this.orderInfoVisible=true;
		},
		showUserOrderList(val){
			console.log(val)
			this.buyOrderId=val.id;
			this.userOrderListVisible=true;
		},
        resetForm() {
            this.$refs.form.resetFields();
        },
        mod(row) {
            this.centerDialogVisible = true;
            this.$nextTick(() => {
                //赋值到表单
                this.form.id = row.id;
                this.form.userId = row.userId;
				this.form.userName = row.userName;
                this.form.remarks = row.remarks;
            });
        },
        add() {
            this.userOrderSelectVisible = true;
        },
		doSelectUserOrder(val){
			console.log(val)
			if(val.length>0){
				var userOrderIds=[]
				val.forEach(item=>{
					userOrderIds.push(item.id)
				})
				this.form.userOrderIds=userOrderIds;
			}
		},
		doSaveBuyOrder(){
			this.$axios
			    .post(this.$httpUrl + "/buyorder/save", this.form)
			    .then((res) => res.data)
			    .then((res) => {
			        console.log(res);
			        if (res.code == 200) {
			            this.$message({
			                message: "操作成功！",
			                type: "success",
			            });
			            this.userOrderSelectVisible = false;
			            this.loadPost();
			            // this.resetForm();
			        } else {
			            this.$message({
			                message: "操作失败！",
			                type: "error",
			            });
			        }
			    });
		},
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1;
            this.pageSize = val;
            this.loadPost();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.loadPost();
        },
        resetParam() {
            this.name = "";
        },
        loadPost() {
            this.$axios
                .post(this.$httpUrl + "/buyorder/listPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {
                        name: this.name,
						daterange:this.daterange
                    },
                })
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.total = res.total;
                    } else {
                        alert("获取数据失败");
                    }
                });
        },
    },
    beforeMount() {
        this.loadPost();
    },
};
</script>

<style scoped>
</style>